import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_header = _resolveComponent("the-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.request && !_ctx.hideHeader)
      ? (_openBlock(), _createBlock(_component_the_header, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["page-layout__container", _ctx.classes])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 64))
}